import { useEffect } from 'react';
import { dialogVariantIcon, dialogVariantTone } from '../lib/appDialog';
import { useDialogStore } from '../store/dialogStore';

export function AppDialogHost() {
  const current = useDialogStore((s) => s.current);
  const close = useDialogStore((s) => s.close);

  const showCancel = current?.showCancel === true;

  useEffect(() => {
    if (!current) return;
    function onKey(ev: KeyboardEvent) {
      if (ev.key === 'Escape') {
        ev.preventDefault();
        close(!showCancel);
      }
    }
    document.addEventListener('keydown', onKey);
    return () => document.removeEventListener('keydown', onKey);
  }, [current, close, showCancel]);

  if (!current) return null;
  const confirmLabel = current.confirmLabel ?? (showCancel ? 'Confirm' : 'OK');
  const cancelLabel = current.cancelLabel ?? 'Cancel';
  const icon = dialogVariantIcon(current.variant, current.icon);

  return (
    <div
      className="app-dialog-backdrop"
      role="presentation"
      onClick={() => close(!showCancel)}
    >
      <div
        className={`app-dialog app-dialog--${current.variant}`}
        role="alertdialog"
        aria-modal
        aria-labelledby="app-dialog-title"
        aria-describedby="app-dialog-message"
        onClick={(e) => e.stopPropagation()}
      >
        <div className={`app-dialog__icon app-dialog__icon--${current.variant}`} aria-hidden>
          <span className="material-symbols-outlined">{icon}</span>
        </div>
        <h2 id="app-dialog-title" className="app-dialog__title">
          {current.title}
        </h2>
        <p id="app-dialog-message" className="app-dialog__message">
          {current.message}
        </p>
        <div className="app-dialog__footer">
          {showCancel ? (
            <button
              type="button"
              className="app-dialog__btn app-dialog__btn--ghost"
              onClick={() => close(false)}
            >
              {cancelLabel}
            </button>
          ) : null}
          <button
            type="button"
            className={`app-dialog__btn app-dialog__confirm ${dialogVariantTone(current.variant)}`}
            autoFocus
            onClick={() => close(true)}
          >
            {confirmLabel}
          </button>
        </div>
      </div>
    </div>
  );
}
